import { render, staticRenderFns } from "./EditSale.vue?vue&type=template&id=97493ff2&scoped=true&"
import script from "./EditSale.vue?vue&type=script&lang=js&"
export * from "./EditSale.vue?vue&type=script&lang=js&"
import style0 from "./EditSale.vue?vue&type=style&index=0&id=97493ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97493ff2",
  null
  
)

export default component.exports